import axios from 'axios'
import 'regenerator-runtime/runtime'
import logger from '../common/logger'

const PARTNER_API_URL =
  process?.env?.PARTNER_API_URL ?? 'https://staging.gu-plat.com/api'

const httpResponse = (res = {}) => {
  return {
    headers: res.header || {},
    data: res.data || {},
    status: res.status || 0,
  }
}

const handleAxiosError = (error) => {
  logger.warn('platform request error', { error })
  if (!error.response && !error.request) throw error
  return error.response
    ? httpResponse(error.response)
    : httpResponse({ status: 500, data: { error: error.request } })
}
const PlatformAPIHttpClient = {
  postVwoDataAsync: (payload) => {
    const apiPath = '/vwo/events-data/'
    return axios
      .post(`${PARTNER_API_URL}${apiPath}`, payload)
      .then(httpResponse, handleAxiosError)
  },
}
export default PlatformAPIHttpClient
